var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 256,
    viewBox: "0 0 327 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4681 207.103C76.1477 214.587 71.8807 216.78 68.0903 217.557C75.1717 217.762 75.9888 218.783 77.9256 226.328C77.1236 220.678 77.169 216.552 84.6136 213.978C83.1383 214.229 75.8148 217.579 74.4681 207.103Z",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.909 23.3676C142.589 30.8522 138.322 33.045 134.531 33.8217C141.613 34.0272 142.43 35.0475 144.367 42.5931C143.565 36.9434 143.61 32.8166 151.055 30.2431C149.579 30.5324 142.233 33.8673 140.909 23.3676Z",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.237 207.103C231.454 208.405 232.823 208.991 234.579 210.91",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.619 210.91C216.459 213.354 217.132 214.717 217.193 217.313",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.448 18.2738C125.021 20.3144 126.081 21.3727 126.981 23.8245",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.602 210.91C199.459 213.194 198.627 214.465 198.219 217.054",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 105.193L116.069 113.995C112.153 114.583 109.256 117.947 109.256 121.907V190.798C109.256 195.689 113.606 199.435 118.443 198.709L201.106 186.308C206.118 185.556 209.177 180.392 207.427 175.635L183.418 110.343C182.108 106.781 178.476 104.629 174.722 105.193Z",
    fill: "#F5B3A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.036 192.469L118.443 198.709C113.606 199.435 109.256 195.689 109.256 190.798V120.977C109.256 119.068 109.913 117.193 111.283 115.863C111.726 115.433 112.123 115.086 112.349 114.972M195.992 144.538L182.286 108.687C181.63 106.97 180.008 105.455 178.17 105.455V105.455",
    stroke: "#01221D",
    strokeWidth: 1.42
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.349 114.972L124.618 105.388C126.126 104.21 127.915 103.446 129.809 103.171L185.286 95.1124C186.221 94.9765 186.805 96.0946 186.16 96.785L178.014 105.495",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.215 95.3375C196.308 92.1631 212.33 126.699 225.956 175.963",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.237 115.734C125.868 101.828 126.341 73.1182 145.611 73.8547C148.305 73.9577 150.962 74.8197 153.086 76.4786C162.408 83.7566 167.205 101.492 168.335 108.881",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.183 100.495C143.022 88.3584 145.276 65.2975 161.261 66.0364C164.58 66.1898 167.807 67.5498 170.189 69.8677C177.239 76.7273 179.988 89.3905 180.482 95.7017",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.697 167.01C193.204 152.029 207.199 152.595 215.313 155.315C217.019 155.887 218.588 156.811 219.972 157.962C237.807 172.789 232.338 196.416 212.167 199.13C191.225 201.948 177.642 187.86 186.697 167.01Z",
    fill: "#07BFA5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.677 177.868C202.616 178.502 216.746 179.391 217.755 177.868",
    stroke: "white",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.298 189.398C206.929 182.415 207.812 168.194 206.298 167.178",
    stroke: "white",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.623 142.951C51.2224 178.502 58.1587 209.483 196.936 142.951C370.408 59.7858 236.047 74.3873 223.431 89.6236C210.814 104.86 248.663 95.9722 237.308 89.6236C225.954 83.2751 207.66 90.8933 194.413 97.2418",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M248.58 27.6966C241.292 29.5473 238.945 23.601 238.611 20.5367C238.564 20.0984 238.279 19.7114 237.857 19.5839L226.918 16.2811C226.386 16.1205 225.825 16.4245 225.669 16.9579L223.031 25.9825C222.896 26.4456 223.111 26.9394 223.542 27.1563L228.055 29.4273C228.606 29.7045 228.777 30.4092 228.415 30.9082L219.1 43.7361C218.046 45.1879 218.493 47.2342 220.057 48.1137L236.005 57.0826C237.428 57.8834 239.231 57.3977 240.06 55.99L248.186 42.1901C248.453 41.7362 249.027 41.5675 249.497 41.8042L252.958 43.5455C253.391 43.7637 253.919 43.639 254.209 43.2498L258.85 37.022C259.154 36.6135 259.104 36.043 258.735 35.6919C256.787 33.8389 254.072 31.121 252.475 29.1448C251.887 28.4174 249.487 27.4665 248.58 27.6966Z",
    fill: "#FFBD59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.908 36.3046L256.732 43.2498C256.442 43.639 255.915 43.7637 255.481 43.5455L252.021 41.8042C251.55 41.5675 250.977 41.7362 250.709 42.1901L242.584 55.99C241.755 57.3977 239.952 57.8834 238.528 57.0826L222.58 48.1137C221.017 47.2342 220.569 45.1879 221.623 43.7361L225.637 38.2092L230.938 30.9082C231.3 30.4092 231.129 29.7045 230.578 29.4273L226.065 27.1563C225.634 26.9394 225.42 26.4456 225.555 25.9825L228.475 15.9895",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3744 95.895C57.4368 90.4915 69.8729 84.1396 79.1178 101.96L84.433 99.27C84.7046 99.1325 85.0272 99.1204 85.2853 99.2805C85.965 99.7021 86.6604 100.419 85.8827 101.093C84.7009 102.117 86.0547 102.284 86.0587 103.987C86.0627 105.689 86.0667 107.392 84.8809 106.714C83.6951 106.036 85.2228 108.245 84.8869 109.268C84.6181 110.086 80.9289 104.737 79.1178 101.96C73.8861 107.308 61.213 113.581 52.3744 95.895C50.7433 97.7149 47.1424 101.185 45.7875 100.508C44.0938 99.6603 47.6432 98.2898 47.1352 98.1207C46.6273 97.9516 45.2715 96.9334 46.2834 95.5689C47.2952 94.2044 47.9731 94.7136 46.9552 93.5242C46.3463 92.8126 46.961 92.0537 47.6395 91.5492C48.0083 91.275 48.5123 91.382 48.8105 91.7305L52.3744 95.895Z",
    fill: "#FF6264"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3744 95.895C57.4368 90.4915 69.8729 84.1396 79.1178 101.96L84.433 99.27C84.7046 99.1325 85.0272 99.1204 85.2853 99.2805C85.965 99.7021 86.6604 100.419 85.8827 101.093C84.7009 102.117 86.0547 102.284 86.0587 103.987C86.0627 105.689 86.0667 107.392 84.8809 106.714C83.6951 106.036 85.2228 108.245 84.8869 109.268C84.6181 110.086 80.9289 104.737 79.1178 101.96C73.8861 107.308 61.213 113.581 52.3744 95.895C50.7433 97.7149 47.1424 101.185 45.7875 100.508C44.0938 99.6603 47.6432 98.2898 47.1352 98.1207C46.6273 97.9516 45.2715 96.9334 46.2834 95.5689C47.2952 94.2044 47.9731 94.7136 46.9552 93.5242C46.3463 92.8126 46.961 92.0537 47.6395 91.5492C48.0083 91.275 48.5123 91.382 48.8105 91.7305L52.3744 95.895Z",
    fill: "#FF6264"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3744 95.895C57.4368 90.4915 69.8729 84.1396 79.1178 101.96M52.3744 95.895C61.213 113.581 73.8861 107.308 79.1178 101.96M52.3744 95.895L48.8105 91.7305C48.5123 91.382 48.0083 91.275 47.6395 91.5492C46.961 92.0537 46.3463 92.8126 46.9552 93.5242C47.9731 94.7136 47.2952 94.2044 46.2834 95.5689C45.2715 96.9334 46.6273 97.9516 47.1352 98.1207C47.6432 98.2898 44.0937 99.6603 45.7875 100.508C47.1424 101.185 50.7433 97.7149 52.3744 95.895ZM79.1178 101.96L84.433 99.27C84.7046 99.1325 85.0272 99.1204 85.2853 99.2805C85.965 99.7021 86.6604 100.419 85.8827 101.093C84.7009 102.117 86.0547 102.284 86.0587 103.987C86.0627 105.689 86.0667 107.392 84.8809 106.714C83.6951 106.036 85.2228 108.245 84.8869 109.268C84.6181 110.086 80.9289 104.737 79.1178 101.96Z",
    stroke: "#01221D",
    strokeWidth: 1.42,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.e979e664236a6ec0b42c922abaee1c62.svg";
export { ForwardRef as ReactComponent };